import { render } from "./TraderAccounts.vue?vue&type=template&id=b475909c&ts=true"
import script from "./TraderAccounts.vue?vue&type=script&lang=ts"
export * from "./TraderAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__